import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_PHARMA_MARKETING_ACTIVITY_REPORT} from '@app/navigations/RoutePathConstant';

const PharmaMarketingActivityReport = lazy(() =>
  import('../../../screens/PharmaMarketingActivityReport')
    .then(module => ({default: module.PharmaMarketingActivityReport})));

const PharmaMarketingActivityReportNavigation = [
  {
    path: ROUTE_PHARMA_MARKETING_ACTIVITY_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <PharmaMarketingActivityReport />
      </Suspense>
    ),
  },
];

export default PharmaMarketingActivityReportNavigation;
